import { gql } from '@apollo/client';

export const CREATE_SPELL_IGNORE_MUTATION = gql`
  mutation createSpellIgnore (
    $jobId: Int!
    $words: [String!]!
  ) {
    createSpellIgnore(
      jobId: $jobId
      words: $words
    ) {
      success
    }
  }
`;

export const DELETE_SPELL_IGNORE_MUTATION = gql`
  mutation deleteSpellIgnore (
    $id: Int!
  ) {
    deleteSpellIgnore(
      id: $id
    ) {
      success
    }
  }
`;
